import { render } from "./SaveBtn.vue?vue&type=template&id=3ff03ece&scoped=true"
const script = {}

import "./SaveBtn.vue?vue&type=style&index=0&id=3ff03ece&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff03ece"]])

export default __exports__